const activityGames = [
  {
    id: 'memoria_funcional_mvp',
    activityId: 'atv_cog_memoria_bandeja_sumiu',
    tipo: 'memory',
    titulo: 'Jogo de memória funcional',
    subtitulo: 'Encontrar pares e sustentar atenção até completar a rodada.',
    descricao: 'Versão interativa da atividade "O que mudou na bandeja?", com cartas grandes, feedback imediato e registro de acertos, tentativas, tempo e pistas.',
    habilidades_alvo: ['cog_memoria', 'cog_atencao'],
    metricas: ['pares_encontrados', 'tentativas', 'erros', 'pistas', 'tempo_segundos'],
    nivelInicial: 2,
    paresPorNivel: { 1: 3, 2: 4, 3: 6 },
    cartas: [
      { id: 'lapis', rotulo: 'Lápis', simbolo: 'LÁPIS' },
      { id: 'livro', rotulo: 'Livro', simbolo: 'LIVRO' },
      { id: 'bola', rotulo: 'Bola', simbolo: 'BOLA' },
      { id: 'copo', rotulo: 'Copo', simbolo: 'COPO' },
      { id: 'chave', rotulo: 'Chave', simbolo: 'CHAVE' },
      { id: 'estrela', rotulo: 'Estrela', simbolo: 'ESTRELA' },
    ],
    adaptacoes: [
      'Usar poucas cartas no nível 1.',
      'Ler os nomes das cartas antes da rodada.',
      'Permitir resposta verbal ou apontamento, sem exigir velocidade.',
      'Usar a pista quando houver frustração ou perda de foco.',
    ],
  },
];

export default activityGames;
